import { RoutesMap } from "../common/routes";

export enum Role {
  SUPER_ADMIN = "Superadministrador",
  ADMIN = "Admin",
  COORDINATOR = "Coordinator",
  AGENT = "Agente",
  ASSISTANT = "Ayudante",
}

export const ROUTES_FOR_ADMIN = [
  {
    module: RoutesMap.HOME,
    navigators: [],
  },
];
